module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Bold-3dc4010c81a2c0b79642a3bbd4840aa8.ttf";